// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2SLy0","colMaxWidth":"Table_colMaxWidth__1Eef-"};